import { Link } from 'react-router-dom';
import { t, getLang } from "../../lang";
import React, {useEffect, useState} from 'react' ;
const data = [ 'menu.home',  'menu.live_casino', 'menu.promotions', 'menu.contact_us'] ;
export default function Footer(){
    const [lang, setLangState] = useState(getLang());

    useEffect(() => {
        const handler = () => setLangState(getLang());
        window.addEventListener("langChanged", handler);
        return () => window.removeEventListener("langChanged", handler);
    }, []);

    return(
        <div className='footer'>
            <div className='footer-logo'>
                {/* <img src='/img/lucky_logo.png' alt='logo' className='logo'/>
                <img src = '/img/adult_only.svg' alt='adult_only' /> */}
            </div>
            <div className='footer-links'>
                {
                    data.map( ( item, index ) => (
                        <Link className={ `footer-link ${ index < 3 ? 'verticalWall' : ''}` } key={ index }>
                            {t(item)}
                        </Link>
                    ) )
                }
            </div>
            {/* <div className='footer-others'>
                <img src='/img/image 2.png' alt='image2' />
            </div> */}
            {/* <div className='footer-copyright'>
                @ 2025 Kingdom Co.,Ltd
            </div> */}
        </div>
    )
}